<template>
  <div class="home-box">
    <div class="ad-box" v-if="bankCode === 'CMBC'">
      广告
    </div>
    <div v-if="bankCode !== 'CMB'" class="share-box" @click="handleShare">
      <img src="https://oss.aqdpay.com/appweb/modelCreditCard/share.png" alt="">
    </div>
    <div class="logo-box">
      <img :src="bankInfo.logoUrl" />
    </div>
    <div class="desc-box">
      <div class="name">{{bankInfo.bankName}}</div>
      <div class="desc">{{bankInfo.couponDesc}}</div>
    </div>
    <div class="apply-box">
      <div class="card-list">
        <van-swipe :autoplay="3000" class="swipe-box">
          <van-swipe-item v-for="(item, index) in cardSwipList" :key="index" @click="handleCard(item)">
            <img class="card-img" :src="item.url" />
          </van-swipe-item>
        </van-swipe>
        <img src="https://oss.aqdpay.com/appweb/modelCreditCard/apply.png" alt="立即申请" class="apply-btn" @click="handleApply" />
      </div>
      <div class="rights-desc" @click="goRights">我已成功申请，领取信用卡权益</div>
      <div class="toast-box" v-if="bankCode === 'CMBC'">温馨提示：点击“立即申请”，将跳转至中国民生银行信用卡申请页面</div>
      <div class="rule-box">
        <!-- 活动权益 -->
        <div v-if="bankInfo.rightsUrl" class="ac-rules">
          <img :src="bankInfo.rightsUrl" alt="">
        </div>
        <!-- 活动详情 -->
        <div v-if="bankInfo.ruleUrl" class="ac-rules">
          <img :src="bankInfo.ruleUrl" alt="">
        </div>
      </div>
    </div>
    <share-sheet :showShare="showShare" @share="handleShareContent" @cancleShare="handleCancelShare"></share-sheet>
  </div>
</template>
<script>
import { Swipe, SwipeItem, Dialog } from 'vant'
import { applyCardState } from '@/api/modelCreditCard'
import { setStore } from '@/utils/index'
import shareSheet from '@/components/shareSheet'

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Dialog.Component.name]: Dialog.Component,
    shareSheet
  },
  data () {
    return {
      showShare: false,
      showType: 0,
      bankCode: 'CMBC',
      idA: null,
      idB: null,
      bankInfo: {},
      bankList: [
        {
          id: 'CMBC',
          logoUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/ms/mslogo.png',
          bankCode: 'CMBC',
          bankName: '申请民生银行信用卡',
          couponDesc: '120元交通优惠券免费领',
          rightsUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/ms/msrights.png',
          ruleUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/ms/msrule.png'
        },
        {
          id: 'BQD',
          logoUrl: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/modelCreditCard/bqd/bqdlogo.png',
          bankCode: 'BQD',
          bankName: '申请青岛银行信用卡',
          couponDesc: '送120元优惠券',
          rightsUrl: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/modelCreditCard/bqd/bqdrights2.png',
          ruleUrl: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/modelCreditCard/bqd/bqdrule2.png'
        },
        {
          id: 'CMB',
          logoUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/cmb/logo.png',
          bankCode: 'CMB',
          bankName: '申请招商银行信用卡',
          couponDesc: '100元交通优惠券免费领',
          rightsUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/cmb/rights.png',
          ruleUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/cmb/rule.png'
        }
      ],
      cardSwipList: [],
      cardList: [
        {
          id: 'CMBC',
          bankCode: 'CMBC',
          name: '民生银行信用卡',
          url: 'https://oss.aqdpay.com/appweb/modelCreditCard/ms/1.png'
        },
        {
          id: 'BQD',
          bankCode: 'BQD',
          name: '青岛银行信用卡',
          url: 'https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/modelCreditCard/bqd/bqdcardface2.png'
        },
        {
          id: 'CMB',
          bankCode: 'CMB',
          name: '招商银行信用卡',
          url: 'https://oss.aqdpay.com/appweb/modelCreditCard/cmb/bank.png'
        }
      ]
    }
  },
  created () {
    const token = this.$route.query.token == null ? this.$route.query.accessToken : this.$route.query.token
    if (token) {
      setStore('token', token)
    }
    this.idA = this.$route.query.idA
    this.idB = this.$route.query.idB
    this.bankCode = this.$route.query.bankCode == null ? 'CMBC' : this.$route.query.bankCode
    const info = this.bankList.find((info) => this.bankCode === info.bankCode)
    this.bankInfo = info
    const cardSwipInfo = this.cardList.find((info) => this.bankCode === info.bankCode)
    this.cardSwipList = [cardSwipInfo]
  },
  methods: {
    // 切换卡片
    handleCard (item) {
      const info = this.bankList.find((info) => item.bankCode === info.bankCode)
      this.bankInfo = info
    },
    // 立即申请
    handleApply () {
      if (this.bankCode === 'BQD') {
        Dialog.confirm({
          title: '温馨提示',
          message: '您即将跳转到银行页面继续申卡服务，是否继续？',
          cancelButtonText: '取消',
          confirmButtonText: '继续',
          confirmButtonColor: '#4F7DFF'
        }).then(() => {
          this.requestApply()
        }).catch(() => {

        })
      } else {
        this.requestApply()
      }

      if (window._czc) {
        if (this.bankCode === 'BQD') {
          window._czc.push(['_trackEvent', '青岛银行信用卡活动', '立即申请APP-青岛信用卡', '青岛信用卡活动首页', '', '023'])
        } else {
          window._czc.push(['_trackEvent', '民生银行信用卡活动', '立即申请APP-民生信用卡', '民生信用卡活动首页', '', '021'])
        }
      }
    },
    requestApply () {
      const requestData = {
        bankCode: this.bankInfo.bankCode
      }
      applyCardState(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          this.state = data.result.state
          const url = data.result.applyUrl
          this.goPage(url)
        }
      })
    },
    goPage (url) {
      // 0-待申请，1-已申请成功
      if (this.state === 1) {
        this.goRights()
      } else {
        window.location.href = url
      }
    },
    goRights () {
      const code = this.bankInfo.bankCode
      this.$router.push({ path: '/mdCardRights', query: { code: code, idA: this.idA, idB: this.idB } })
    },
    // 跳转便捷青岛APP
    goApp () {
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    },
    // 分享
    handleShare () {
      this.showShare = true
    },
    handleCancelShare () {
      this.showShare = false
    },
    handleShareContent (type) {
      this.showType = type
      const preFix = window.location.hostname
      console.log(preFix)
      const url = this.bankCode === 'BQD' ? `${preFix}/appweb/mdBQDCardShare` : `${preFix}/appweb/mdCardShare`
      dsBridge.call('callShareWithType', {
        thirdType: this.showType,
        contentShareType: 3,
        title: '便捷青岛限时送福利，120元优惠券免费领！',
        content: '琴岛通隧e通用户专属，登录便捷青岛APP立即参与活动',
        image: 'https://oss.aqdpay.com/appweb/modelCreditCard/sharewximg.jpg',
        urlStr: url
      }, function () {})
      this.showShare = false
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
  background: #ff7253 url('https://oss.aqdpay.com/appweb/modelCreditCard/bg.png') no-repeat;
  background-size: 100%;
  overflow-x: hidden;
}
.logo-box {
  margin-top: 12px;
  img {
    width: 100%;
  }
}
.desc-box {
  margin: 15px 0;
  font-size: 28px;
  color: #FEDDA8;
  line-height: 1.6;
  .name {
    text-align: center;
  }
  .desc {
    text-align: center;
  }
}
.apply-box {
  position: relative;
}
.rights-desc {
  margin: 15px 0;
  font-size: 15px;
  color: #FEDDA8;
  text-align: center;
  text-decoration: underline;
}
.toast-box {
  margin: 15px 0;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
.card-list {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 350px;
  background: url('https://oss.aqdpay.com/appweb/modelCreditCard/red.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 12%;
}
.swipe-box {
  width: 60%;
  height: 144px;
  margin: 0 auto;
}
.card-img {
  width: 100%;
  max-height: 100%;
  margin: 0 auto;
}
.apply-btn {
  position: absolute;
  bottom: 10%;
  left: 50%;
  width: 70px;
  height: 70px;
  transform: translateX(-50%);
}
.rule-box {
  margin: 15px 0;
}
.ac-rules {
  margin: 15px;
  img {
    width: 100%;
  }
}
.ad-box {
  position: absolute;
  top: 0.6%;
  right: 3.5%;
  height: 16.5px;
  font-size: 17.39px;
  color: #fff;
}
.share-box {
  position: absolute;
  top: 2.1%;
  right: 3.5%;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
